/* Mushy · Cart Drawer
   Mengen, Entfernen, Upgrade und die Zusatzleistung laufen ueber Shopifys
   Cart-AJAX. Neu gezeichnet wird ueber die Section Rendering API: der Server
   liefert genau dieses Markup zurueck, wir tauschen den Inhalt aus. Kein
   Neuladen der Seite, und keine zweite Wahrheit ueber den Warenkorb im JS. */

if (!customElements.get('mu-cart-drawer')) {
  customElements.define(
    'mu-cart-drawer',
    class MuCartDrawer extends HTMLElement {
      static OFF_KEY = 'mu-protect-off';

      connectedCallback() {
        this.section = this.dataset.section;
        this.bind();
        this.catchCartLinks();
        this.catchBuyForms();

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !this.hidden) this.close();
        });

        // Klick neben das Panel schliesst den Drawer. Haengt bewusst am Host
        // und nicht am Overlay, damit es auch dann greift, wenn das Overlay
        // durch eine Fremdregel wegfaellt.
        this.addEventListener('click', (e) => {
          if (this.hidden) return;
          if (!e.target.closest('.mu-drawer__panel')) this.close();
        });
      }

      // Klicks auf Warenkorb-Links oeffnen den Drawer, statt zur Cart-Seite zu gehen.
      catchCartLinks() {
        document.addEventListener('click', (e) => {
          const link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble');
          if (!link || this.contains(link)) return;
          e.preventDefault();
          this.open();
        });
      }

      // Kaufformulare gehen per Fetch in den Warenkorb. Ohne das schickt
      // der Browser sie nativ ab, und Shopify antwortet bei einer
      // ausverkauften Variante mit seiner Fehlerseite statt mit der PDP.
      catchBuyForms() {
        document.addEventListener('submit', async (e) => {
          const form = e.target.closest('.mu-buy-form');
          if (!form) return;
          e.preventDefault();

          const button = form.querySelector('[type="submit"]');
          const note = form.querySelector('.mu-buy-form__note');
          const id = form.querySelector('[name="id"]');
          if (!id) return;

          // Abo mitnehmen. Liegt im Formular ein Selling Plan, muss er mit in
          // den Warenkorb, sonst landet der Artikel als Einmalkauf drin.
          const plan = form.querySelector('[name="selling_plan"]');

          if (button) { button.disabled = true; button.classList.add('is-loading'); }
          if (note) note.hidden = true;

          const item = { id: Number(id.value), quantity: 1 };
          if (plan && plan.value) item.selling_plan = Number(plan.value);

          // Gewaehlte Zugaben derselben Buy-Box gehen als eigene Positionen mit,
          // sobald am Block ein Artikel hinterlegt ist. Ohne Artikel bleibt es
          // bei der Notiz, die mu-gifts.js ins Formular schreibt.
          const items = [item];

          // Gratisbeutel der Staffel (2 + 1, 3 + 2). Den Preis setzt der
          // BXGY-Rabatt in Shopify auf 0, hier kommt nur die Menge dazu.
          const freeId = form.querySelector('[data-free-id]');
          const freeQty = form.querySelector('[data-free-qty]');
          if (freeId && freeId.value && freeQty && Number(freeQty.value) > 0) {
            const free = { id: Number(freeId.value), quantity: Number(freeQty.value) };
            const freeNote = form.querySelector('[data-free-note]');
            if (freeNote && freeNote.value) free.properties = { Zugabe: freeNote.value };
            items.push(free);
          }

          const box = form.closest('.mu-buybox');
          if (box) {
            // Der Name des Bundles, nicht der Seitentitel: der steht sonst mit
            // Shop-Namen und Trennstrich in der Bestellung.
            const heading = box.querySelector('.mu-buybox__title');
            const bundleName = heading ? heading.textContent.trim() : document.title;
            box.querySelectorAll('.mu-gift-pick[aria-pressed="true"][data-variant]').forEach((pick) => {
              items.push({
                id: Number(pick.dataset.variant),
                quantity: 1,
                properties: { 'Zugabe zu': bundleName },
              });
            });
          }

          const err = await this.post('/cart/add.js', { items });

          if (button) { button.disabled = false; button.classList.remove('is-loading'); }
          if (err) {
            if (note) { note.textContent = err; note.hidden = false; }
            return;
          }
          this.open();
        });
      }

      bind() {
        this.querySelectorAll('[data-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        this.querySelectorAll('[data-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const row = btn.closest('[data-key]');
            if (!row) return;
            this.change({ id: row.dataset.key, quantity: Number(btn.dataset.change) });
          });
        });

        this.querySelectorAll('[data-add]').forEach((btn) => {
          btn.addEventListener('click', async () => {
            // Ohne Rueckmeldung klickt man zweimal: der Warenkorb schreibt
            // ueber das Netz zurueck, das dauert einen Moment.
            btn.classList.add('is-loading');
            btn.disabled = true;
            try {
              if (btn.dataset.replace) {
                await this.upgrade(btn.dataset.add, btn.dataset.replace.split(','), Number(btn.dataset.qty || 1));
              } else {
                await this.add(btn.dataset.add);
              }
            } finally {
              // Nach dem Neuzeichnen ist der Knopf ohnehin weg; steht er noch
              // da, weil etwas schiefging, muss er wieder klickbar sein.
              btn.classList.remove('is-loading');
              btn.disabled = false;
            }
          });
        });

        const prot = this.querySelector('[data-protection]');
        if (prot) {
          prot.addEventListener('change', () => {
            if (prot.checked) {
              this.forget(MuCartDrawer.OFF_KEY);
              this.add(prot.dataset.variant);
            } else if (prot.dataset.key) {
              // Wer abwaehlt, bekommt sie nicht beim naechsten Rendern zurueck.
              this.remember(MuCartDrawer.OFF_KEY);
              this.change({ id: prot.dataset.key, quantity: 0 });
            }
          });
        }

        this.dropLoneProtection();
        this.autoProtect();
      }

      /* Bleibt nach dem Entfernen des letzten Artikels nur die Zusatzleistung
         liegen, waere der Warenkorb optisch leer und im Checkout trotzdem
         gefuellt. Also mit raus. */
      dropLoneProtection() {
        if (Number(this.dataset.itemCount || 0) > 0) return;
        if (this.dataset.protectInCart !== 'true') return;
        const key = this.dataset.protectKey;
        if (!key) return;
        this.change({ id: key, quantity: 0 });
      }

      /* Die Zusatzleistung ist ein echtes Produkt: "von Haus aus an" heisst,
         sie einmal selbst in den Warenkorb zu legen, sobald etwas drin ist.
         Genau einmal pro Seitenaufruf, sonst legt das erneute Rendern nach
         jedem Zurueckschreiben eine Schleife an. */
      autoProtect() {
        if (this.autoDone) return;
        if (this.dataset.protectDefault !== 'true') return;
        if (this.dataset.protectInCart === 'true') return;

        const id = this.dataset.protectVariant;
        if (!id || id === '0') return;
        if (Number(this.dataset.itemCount || 0) < 1) return;
        if (this.recalls(MuCartDrawer.OFF_KEY)) return;

        this.autoDone = true;
        this.add(id);
      }

      remember(key) {
        try { sessionStorage.setItem(key, '1'); } catch (e) { this.fallback = true; }
      }

      forget(key) {
        try { sessionStorage.removeItem(key); } catch (e) { this.fallback = false; }
        this.autoDone = false;
      }

      recalls(key) {
        try { return sessionStorage.getItem(key) === '1'; } catch (e) { return !!this.fallback; }
      }

      open() {
        this.hidden = false;
        document.body.classList.add('mu-drawer-open');
        const close = this.querySelector('.mu-drawer__close');
        if (close) close.focus();
      }

      close() {
        this.hidden = true;
        document.body.classList.remove('mu-drawer-open');
      }

      busy(state) {
        this.classList.toggle('is-busy', state);
      }

      async change(body) {
        await this.post('/cart/change.js', body);
      }

      async add(id) {
        await this.post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      }

      /* Upgrade ist ein Tausch, kein zweiter Artikel: erst das bessere Bundle
         hineinlegen, dann die Zeilen entfernen, die es ersetzt. Die Reihenfolge
         ist wichtig — andersherum waere der Warenkorb zwischendurch leer und
         dropLoneProtection wuerfe die Zusatzleistung mit hinaus. Der erste
         Aufruf zeichnet nicht neu, sonst blitzt der Zwischenstand mit beiden
         Bundles auf. */
      async upgrade(id, keys, qty) {
        const err = await this.post(
          '/cart/add.js',
          { items: [{ id: Number(id), quantity: qty > 0 ? qty : 1 }] },
          true
        );
        if (err) return err;

        const updates = {};
        keys.filter(Boolean).forEach((key) => { updates[key] = 0; });
        return this.post('/cart/update.js', { updates });
      }

      async post(url, body, quiet) {
        this.busy(true);

        try {
          const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...body, sections: this.section }),
          });

          const data = await res.json();

          if (!res.ok) {
            // Shopify liefert bei Fehlern eine description, etwa wenn der
            // Bestand nicht reicht. Der Aufrufer zeigt sie an, der Drawer
            // bleibt, wie er war.
            return data.description || data.message || 'Das hat nicht geklappt. Bitte noch einmal versuchen.';
          }

          if (!quiet) this.render(data.sections && data.sections[this.section]);
          return null;
        } catch (e) {
          return 'Warenkorb gerade nicht erreichbar. Bitte noch einmal versuchen.';
        } finally {
          this.busy(false);
        }
      }

      render(html) {
        if (!html) return;

        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('mu-cart-drawer');
        if (!fresh) return;

        const wasOpen = !this.hidden;
        this.innerHTML = fresh.innerHTML;
        this.dataset.itemCount = fresh.dataset.itemCount;
        this.hidden = !wasOpen;

        this.bind();
        this.syncBubble(fresh.dataset.itemCount);
      }

      // Dawns Zaehler am Header mitziehen, sonst zeigt er den alten Stand.
      syncBubble(count) {
        const n = Number(count || 0);
        document.querySelectorAll('.cart-count-bubble span:first-child').forEach((el) => {
          el.textContent = n;
        });
        document.querySelectorAll('.cart-count-bubble').forEach((el) => {
          el.hidden = n === 0;
        });
      }
    }
  );
}
